import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Consulta Giovanile di Ortona</h3>
          <p>Promuoviamo la partecipazione giovanile e lo sviluppo della comunità.</p>
        </div>
        
        <div className="footer-section">
          <h4>Link Rapidi</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">Chi Siamo</Link></li>
            <li><Link to="/articles">Articoli</Link></li>
            <li><Link to="/events">Eventi</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Contatti</h4>
          <ul>
            <li><Link to="/contact">consultagiovanile@comune.ortona.ch.it</Link></li>
            <li><Link to="/contact">consultagiovanileortona@gmail.com</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Seguici</h4>
          <div className="social-links">
            <a href="https://www.facebook.com/consulta.giovanilediortona" aria-label="Facebook">
              <i className="fa-brands fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/consultagiovanileortona/" aria-label="Instagram">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/consulta-giovanile-di-ortona" aria-label="LinkedIn">
              <i className="fa-brands fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p> 2021 - {new Date().getFullYear()} Sviluppato da Fabio Alfineo di Gabriele</p>
      </div>
    </footer>
  );
}

export default Footer;
